export default __webpack_public_path__ + "static/media/pexels-andrea-piacquadio-3756165.13653a1e.jpg";